import React from 'react'
import { FormSelectSales } from 'src/components/form-elements/custom-form-select.SalesSettings.component'
import { GetTranslation } from 'src/services/fleet-translation-http.service'
import { makeStyles } from '@material-ui/core/styles';

const useSelectStyles = makeStyles((theme) => ({
    SelectControl: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        minWidth: "100%",
    },
}));

const ColorSelect = ({ onChange, variant, value, placeholder }) => {
    const [color, setColor] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const classes = useSelectStyles();

    React.useEffect(() => {
        selectVehicleColor();
    }, []);

    const selectVehicleColor = () => {
        let colorArray = [];

        GetTranslation(['COLOR'])
            .then(data => {               
                Array.isArray(data) && data.length > 0 ? data.map((color, key) => { key={key}
                    colorArray.push({ key: color.fleetValue, value: color.integratorValue });
                })
                    : console.log("Error Occured");
                    setColor(colorArray);
            });
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <FormSelectSales
            className={classes.SelectControl}
            label="Color"
            id="color"
            name={''}
            open={open}
            onOpen={handleOpen}
            onClose={handleClose}
            value={value}
            onChange={onChange}
            menuObjectArray={color}
            variant={variant ? variant : false}
            placeholder={placeholder}
        />
    )
}

export default ColorSelect;